import Vue from 'vue'
import DateFormat from './date-format'
import MoneyFormat from './money-format'
import StrFormat from './str-format'

// 全局注册过滤器
Vue.use(DateFormat)
Vue.use(MoneyFormat)
Vue.use(StrFormat)



// WEBPACK FOOTER //
// ./src/filters/index.js